module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('b', [_vm._v("“How do they do that?”")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You know the type. Give them a fresh challenge and somehow, like Dr. Brown and his team, they find a pathway to success. Nothing in particular about their skills or expertise would make them a natural fit to succeed, yet they seem to thrive no matter the circumstances. Stumbles? Setbacks? Not an issue. In fact, they bounce back from failure time after time and often come back better than ever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s a rare and valuable talent. These individuals make a name for themselves as the go-to leaders in situations where the stakes are high, the problems lack clarity, and the solutions aren’t easy to identify, much less execute: starting up an overseas operation, implementing a complex new technology, turning around an underperforming product line, leading a postmerger integration team.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Success in these types of situations often leads to opportunities to once again lead the organization into the unknown, take on daunting risks, and achieve the success that has eluded others. As a result, the careers of these individuals resemble less a steady climb up the ladder than a series of adventures that lead both them and the organization to new and exciting places.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what is it that these people do to make them such unique and special talents? Some characteristics come to mind—curious, insightful, resourceful, adaptable, savvy, resilient—but no single one seems to capture what sets them apart. That’s because it’s not a single trait, but rather an integrated set of behaviors, that underlies their success.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Through decades of research, CCL has gained insight into the exact nature of these behaviors, collectively called learning agility. We also understand how these behaviors can be developed. What’s more, while many people don’t possess high levels of learning agility, it can be learned and anyone can become more proficient.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This book will decode the mystery behind learning-agile individuals’ abilities and put you on the path to developing these abilities for yourself. At the heart of learning agility is something that we all have but we might not always see or leverage the value in—our experience. Through the information, exercises, and tools captured here, you’ll learn a new way to think about, approach, and apply your experiences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We’ll use some of the experiences you’ve already had as a learning tool to guide you through the core elements of developing your learning agility. So, before you go any further, take a moment to reflect and respond to the questions that follow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, think about a specific experience where you were at your best and the outcomes were positive. Briefly describe the situation and the end result.")])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('b', [_vm._v("MY POSITIVE EXPERIENCE")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("How would you describe the situation?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("What was the end result?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Second, think about another experience where, by contrast, you were far from your best and the outcomes were negative. Briefly describe the situation and the end result below.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("MY NEGATIVE EXPERIENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("How would you describe the situation?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("What was the end result?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("We’ll revisit these experiences and explore them more deeply at various points throughout the book. But next, let’s learn more about why experience is so valuable and the role it plays in developing your learning agility.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e62ef9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter02.vue
// module id = 75
// module chunks = 0